import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import KitchenPurchaseNewEditForm from '../kitchen-purchase-new-edit-form';

export default function KitchenCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <CustomBreadcrumbs
        heading="Create a new purchase order"
        links={[
          {
            name: 'Purchase Orders',
            href: paths.dashboard.kitchen.purchase.root(),
          },
          { name: 'Create a new purchase order' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <KitchenPurchaseNewEditForm />
    </Container>
  );
}
